import PropTypes from "prop-types";
import {
    Autocomplete,
    Button,
    Checkbox,
    FormControlLabel,
    InputAdornment,
    Stack,
    Switch,
    TextField
} from '@mui/material';
import Iconify from "../../components/Iconify";
import { DatePicker } from "@mui/x-date-pickers";
import { CalendarIconSvg } from "../../constants/icons";
import moment from "moment";
import { useSnackbar } from "notistack";

DepartureFromSpotToolbar.propTypes = {
    isFiltered: PropTypes.bool,
    filterLineName: PropTypes.string,
    filterOperatorName: PropTypes.string,
    filterDate: PropTypes.string,
    filterDateTo: PropTypes.string,
    filterCanceledNote: PropTypes.string,
    filterDepartureTime: PropTypes.string,
    filterRootDepartureTime: PropTypes.string,
    filterArrivalTime: PropTypes.string,
    enaleAllStations: PropTypes.bool,
    onResetFilter: PropTypes.func,
    onFilterOperatorName: PropTypes.func,
    onFilterLineName: PropTypes.func,
    onFilterDate: PropTypes.func,
    onFilterDateTo: PropTypes.func,
    onFilterCanceledNote: PropTypes.func,
    onFilterDepartureTime: PropTypes.func,
    onFilterRootDepartureTime: PropTypes.func,
    onFilterArrivalTime: PropTypes.func,
    departureTimeOptions: PropTypes.array,
    rootDepartureTimeOptions: PropTypes.array,
    arrivalTimeOptions: PropTypes.array,
    showWithComment: PropTypes.bool,
    onShowWithComment: PropTypes.func,
};

export default function DepartureFromSpotToolbar({
    arrStationId,
    enableAllStations,
    setEnableAllStations,
    setEndStation,
    isIndividual,
    homeArrStations,
    operator,
    isFiltered,
    filterLineName,
    filterOperatorName,
    filterDate,
    filterDateTo,
    filterCanceledNote,
    filterDepartureTime,
    filterRootDepartureTime,
    filterArrivalTime,
    onFilterLineName,
    onFilterDate,
    onFilterDateTo,
    onFilterOperatorName,
    onFilterCanceledNote,
    onFilterDepartureTime,
    onFilterRootDepartureTime,
    onFilterArrivalTime,
    departureTimeOptions = [],
    rootDepartureTimeOptions = [],
    arrivalTimeOptions = [],
    onResetFilter,
    showWithComment,
    onShowWithComment
}) {
    const { enqueueSnackbar } = useSnackbar();

    const arr = homeArrStations?.length > 0
        ? [
            ...homeArrStations.map(item => ({
                id: item.id,
                name: item.stationName,
                locationId: item.locationId,
                locationName: item.locationName,
            })),
        ]
        : [];

    const locationID = homeArrStations.find(i => i.id === arrStationId)?.locationId
    const returnStations = homeArrStations.filter(f => f.locationId === locationID).map(item => ({
        id: item.id,
        name: item.stationName,
        locationId: item.locationId,
        locationName: item.locationName,
    }))

    const showStationsToChoose = isIndividual !== false ? enableAllStations : true

    return (
        <>
            <Stack
                spacing={2}
                alignItems="center"
                direction={{
                    xs: 'column',
                    sm: 'row',
                }}
                sx={{ px: 2.5, py: 3 }}
            >
                {showStationsToChoose &&
                    <Autocomplete
                        fullWidth
                        name="endStation"
                        onChange={(e, data) => {
                            if (data) {
                                setEndStation(data);
                            }
                        }}
                        options={enableAllStations ? returnStations : arr}
                        getOptionLabel={(option) => option.name || ""}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                size="small"
                                label={"Izaberite stanicu"}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />

                }

                <TextField
                    size={"small"}
                    fullWidth
                    value={filterLineName}
                    onChange={onFilterLineName}
                    placeholder="Naziv linije..."
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                            </InputAdornment>
                        ),
                    }}
                />

                {
                    !operator && <TextField
                        size={"small"}
                        fullWidth
                        value={filterOperatorName}
                        onChange={onFilterOperatorName}
                        placeholder="Naziv prevoznika..."
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                }

                <TextField
                    size={"small"}
                    fullWidth
                    value={filterCanceledNote || ""}
                    onChange={onFilterCanceledNote}
                    placeholder="Komentar..."
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                            </InputAdornment>
                        ),
                    }}
                />
            </Stack>

            <Stack
                spacing={2}
                alignItems="center"
                direction={{
                    xs: 'column',
                    sm: 'row',
                }}
                sx={{ px: 2.5, pb: 2 }}
            >
                <Autocomplete
                    fullWidth
                    size="small"
                    options={rootDepartureTimeOptions}
                    value={filterRootDepartureTime}
                    onChange={(e, value) => onFilterRootDepartureTime(value)}
                    getOptionLabel={(option) => option ? option : ""}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Početno vreme polaska"
                            placeholder="Izaberite vreme..."
                        />
                    )}
                />

                <Autocomplete
                    fullWidth
                    size="small"
                    options={departureTimeOptions}
                    value={filterDepartureTime}
                    onChange={(e, value) => onFilterDepartureTime(value)}
                    getOptionLabel={(option) => option ? moment(option).format("DD.MM.YYYY HH:mm") : ""}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Vreme polaska"
                            placeholder="Izaberite vreme..."
                        />
                    )}
                />

                <Autocomplete
                    fullWidth
                    size="small"
                    options={arrivalTimeOptions}
                    value={filterArrivalTime}
                    onChange={(e, value) => onFilterArrivalTime(value)}
                    getOptionLabel={(option) => option ? moment(option).format("DD.MM.YYYY HH:mm") : ""}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Vreme dolaska"
                            placeholder="Izaberite vreme..."
                        />
                    )}
                />

                <DatePicker
                    views={['year', 'month', 'day']}
                    disablePast={true}
                    sx={{ width: 550 }}
                    label="Datum od"
                    format="dd-MM-yy"
                    value={new Date(filterDate) || null}
                    onChange={(newValue) => {
                        onFilterDate(newValue);

                        const newDateFrom = moment(newValue).startOf('day');
                        const currentDateTo = filterDateTo ? moment(filterDateTo).startOf('day') : null;

                        const minDateTo = newDateFrom.clone().add(1, 'day');
                        const maxDateTo = newDateFrom.clone().add(90, 'days');

                        if (!currentDateTo || currentDateTo.isSameOrBefore(newDateFrom)) {
                            onFilterDateTo(minDateTo.toDate());
                        } else if (currentDateTo.isAfter(maxDateTo)) {
                            onFilterDateTo(maxDateTo.toDate());
                        }
                    }}
                    slotProps={{ textField: { size: 'small' } }}
                    slots={{ openPickerIcon: CalendarIconSvg }}
                    renderInput={(params) => (
                        <TextField
                            size="small"
                            {...params}
                        />
                    )}
                />

                <DatePicker
                    views={['year', 'month', 'day']}
                    sx={{ width: 550 }}
                    label="Datum do"
                    format="dd-MM-yy"
                    value={filterDateTo ? new Date(filterDateTo) : null}
                    minDate={moment(filterDate).add(1, 'day').toDate()}
                    maxDate={moment(filterDate).add(90, 'days').toDate()}
                    onChange={(newValue) => {
                        const dateFrom = moment(filterDate).startOf('day');
                        const newDateTo = moment(newValue).startOf('day');
                        const minDate = dateFrom.clone().add(1, 'day');
                        const maxDate = dateFrom.clone().add(90, 'days');
                        const diffDays = newDateTo.diff(dateFrom, 'days');

                        if (diffDays <= 0) {
                            onFilterDateTo(minDate.toDate());
                            enqueueSnackbar("Datum 'Do' mora biti veći od datuma 'Od'", { variant: "warning" });
                            return;
                        }
                        if (diffDays > 90) {
                            onFilterDateTo(maxDate.toDate());
                            enqueueSnackbar("Datum 'Do' može biti maksimalno 90 dana od datuma 'Od'", { variant: "warning" });
                            return;
                        }

                        onFilterDateTo(newValue);
                    }}
                    slotProps={{ textField: { size: 'small' } }}
                    slots={{ openPickerIcon: CalendarIconSvg }}
                    renderInput={(params) => (
                        <TextField
                            size="small"
                            {...params}
                        />
                    )}
                />


                {
                    isFiltered && (
                        <Button
                            color="error"
                            sx={{ flexShrink: 0 }}
                            onClick={onResetFilter}
                            startIcon={<Iconify icon="eva:trash-2-outline" />}
                        >
                            Očisti
                        </Button>
                    )
                }
            </Stack>
            <Stack direction="row" gap={1}>
                {isIndividual &&
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={enableAllStations}
                                    onChange={(event) => setEnableAllStations(event.target.checked)} />}
                            label="Uključi prikaz svih stanica za ovu lokaciju u pretrazi" />
                }
                <FormControlLabel
                    control={
                        <Switch
                            checked={showWithComment}
                            onChange={(event) => onShowWithComment(event.target.checked)} />}
                    label="Prikaži polaske sa komentarom" />
            </Stack>
        </>
    )
}
